(() => {
  if (window.orelvaneWaveSections) { window.orelvaneWaveSections.init(document); return; }
  const states = new WeakMap();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function setup(root) {
    if (states.has(root)) return;
    const controller = new AbortController(), cleanups = [];
    const listen = (el, type, fn, options = {}) => el.addEventListener(type, fn, {...options, signal: controller.signal});
    const state = { destroy() { controller.abort(); cleanups.forEach(fn => fn()); }, selectBlock() {} };
    states.set(root, state);
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    const showTab = (index, focus = false) => {
      tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      panels.forEach((panel, i) => { panel.hidden = i !== index; });
      if (focus) tabs[index]?.focus();
    };
    tabs.forEach((tab, i) => {
      listen(tab, 'click', () => showTab(i));
      listen(tab, 'keydown', event => {
        let target = i;
        if (event.key === 'ArrowRight') target = (i + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') target = (i - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = tabs.length - 1;
        else return;
        event.preventDefault(); showTab(target, true);
      });
    });
    const marquee = root.querySelector('[data-marquee]');
    if (marquee) {
      const toggle = marquee.querySelector('[data-motion-toggle]');
      listen(toggle, 'click', () => {
        const paused = marquee.classList.toggle('is-paused');
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? 'Resume scrolling text' : 'Pause scrolling text');
        toggle.textContent = paused ? '▶' : 'Ⅱ';
      });
    }
    const faq = root.querySelector('.ov-faq-list');
    if (faq) faq.querySelectorAll('details').forEach(detail => listen(detail, 'toggle', () => {
      if (detail.open && faq.dataset.single === 'true') faq.querySelectorAll('details').forEach(other => { if (other !== detail) other.open = false; });
    }));
    const carousel = root.querySelector('[data-carousel]');
    let go = () => {};
    if (carousel) {
      const track = carousel.querySelector('.ov-carousel-track'), slides = [...track.querySelectorAll('.ov-slide')];
      const dots = [...carousel.querySelectorAll('[data-slide]')], pause = carousel.querySelector('[data-carousel-pause]');
      let index = 0, timer = null, paused = false, hover = false, frame = 0;
      const update = () => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let best = Infinity;
        slides.forEach((slide, i) => { const distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center); if (distance < best) { best = distance; index = i; } });
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      };
      go = (next, user = false) => {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        const slide = slides[index];
        track.scrollTo({left: slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2, behavior: motion.matches ? 'instant' : 'smooth'});
        if (user) carousel.querySelector('[data-carousel-status]').textContent = `Detail ${index + 1} of ${slides.length}`;
      };
      const stop = () => { clearInterval(timer); timer = null; };
      const start = () => { stop(); if (carousel.dataset.autoplay === 'true' && !paused && !hover && !motion.matches && !document.hidden && !carousel.contains(document.activeElement) && slides.length > 1) timer = setInterval(() => go(index + 1), Number(carousel.dataset.interval || 6) * 1000); };
      listen(track, 'scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive:true});
      listen(track, 'keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); paused = true; stop(); go(index + (event.key === 'ArrowRight' ? 1 : -1), true); } });
      listen(carousel.querySelector('[data-prev]'), 'click', () => { stop(); go(index - 1, true); start(); });
      listen(carousel.querySelector('[data-next]'), 'click', () => { stop(); go(index + 1, true); start(); });
      dots.forEach((dot, i) => listen(dot, 'click', () => { stop(); go(i, true); start(); }));
      listen(carousel, 'mouseenter', () => { hover = true; stop(); });
      listen(carousel, 'mouseleave', () => { hover = false; start(); });
      listen(carousel, 'focusin', stop);
      listen(carousel, 'focusout', event => { if (!carousel.contains(event.relatedTarget)) start(); });
      listen(track, 'pointerdown', stop, {passive:true});
      listen(track, 'pointerup', start, {passive:true});
      listen(document, 'visibilitychange', start);
      listen(motion, 'change', start);
      if (pause) listen(pause, 'click', () => { paused = !paused; pause.setAttribute('aria-pressed', String(paused)); pause.setAttribute('aria-label', paused ? 'Resume carousel' : 'Pause carousel'); pause.textContent = paused ? '▶' : 'Ⅱ'; start(); });
      const observer = new ResizeObserver(update); observer.observe(track);
      cleanups.push(() => { stop(); observer.disconnect(); cancelAnimationFrame(frame); });
      update(); start();
    }
    state.selectBlock = blockId => {
      const p = panels.findIndex(panel => panel.dataset.blockId === blockId);
      if (p >= 0) showTab(p);
      const slides = [...root.querySelectorAll('.ov-slide')], s = slides.findIndex(slide => slide.dataset.blockId === blockId);
      if (s >= 0) go(s);
      root.querySelectorAll('details').forEach(detail => { if (detail.dataset.blockId === blockId) detail.open = true; });
    };
    if (root.dataset.reveal === 'true' && !motion.matches && !window.Shopify?.designMode && root.getBoundingClientRect().top > innerHeight) {
      root.classList.add('ov-wait-reveal');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { root.classList.remove('ov-wait-reveal'); root.classList.add('ov-revealed'); observer.disconnect(); } }), {threshold:0.05});
      observer.observe(root); cleanups.push(() => observer.disconnect());
    }
  }
  function init(container) {
    if (container.matches?.('[data-ov-root]')) setup(container);
    container.querySelectorAll('[data-ov-root]').forEach(setup);
  }
  window.orelvaneWaveSections = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true}); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ov-root]').forEach(root => { states.get(root)?.destroy(); states.delete(root); }));
  document.addEventListener('shopify:block:select', event => {
    const blockId = event.detail?.blockId;
    event.target.closest('[data-ov-root]') && states.get(event.target.closest('[data-ov-root]'))?.selectBlock(blockId);
  });
})();
